import { IUsers } from "common/interfaces";
import { TFirestoreTimestamp } from "common/types/FirebaseTypes";

/**
 * Modelo de empresas.
 * @category Users
 * @interface Company
 * @hideconstructor
 */

export class Company {
  name: string;
  users: IUsers;
  image?: string;
  modifiedAt?: TFirestoreTimestamp;
  createdAt?: TFirestoreTimestamp;
  constructor(
    name: string,
    users: IUsers,
    image?: string,
    modifiedAt?: TFirestoreTimestamp,
    createdAt?: TFirestoreTimestamp
  ) {
    /** Nome da empresa.
     * @type {string}
     */
    this.name = name;
    /** Usuários pertencentes a empresa.</br>
     * 0 - Administrador</br>
     * 1 - Colaborador
     * @type {IUsers}
     */
    this.users = users;
    /** URL da logo da empresa.
     * @type {string=}
     */
    this.image = image;
    /** Data de criação da empresa.
     * @type {TFirestoreTimestamp=}
     */
    this.createdAt = createdAt;
    /** Data de modificação da empresa.
     * @type {TFirestoreTimestamp=}
     */
    this.modifiedAt = modifiedAt;
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/models/Company.ts